import React, { createContext, useContext } from "react";
import { Divider, Drawer, Skeleton, Timeline } from "antd";
import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { Observer, observer } from "mobx-react-lite";
import { Radio } from "antd";

import _ from "underscore";
import { AlertTriangle, Edit3, Lock, User } from "react-feather";
import moment from "moment";
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
export const UploadStatus = observer(() => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);

  return (
    <Drawer
      title="NAOC Monthly Production Upload Status"
      placement="right"
      onClose={() => {
        monthlyPerformanceStore.showUploadStatusDialog = false;
      }}
      width={"35%"}
      visible={monthlyPerformanceStore.showUploadStatusDialog}
    >
      {monthlyPerformanceStore.isLoadingStatus ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <Divider>Production Years</Divider>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div
              className="ms-Grid-col ms-sm12"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Observer>
                {() => (
                  <Radio.Group
                    defaultValue={MonthlyPerformanceStore.statusYear}
                    size="large"
                    optionType="button"
                    buttonStyle="solid"
                    defaultChecked
                    onChange={({ target }) => {
                      monthlyPerformanceStore.statusYear = target.value;
                    }}
                  >
                    {_.uniq(
                      [
                        ...monthlyPerformanceStore.uploadStatusItems.values(),
                      ].map((item) => item.prodYear)
                    ).map((prodYear) => (
                      <Radio.Button value={prodYear} key={prodYear}>
                        {prodYear}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                )}
              </Observer>
            </div>
          </div>
          <Divider>Monthly Production Data Lock Status</Divider>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              {
                <Timeline mode={"left"}>
                  {_.where(
                    [...monthlyPerformanceStore.uploadStatusItems.values()],
                    { prodYear: monthlyPerformanceStore.statusYear }
                  ).map((item) => (
                    <Timeline.Item
                      label={item.monthName}
                      color={item.dataLockStatus === 2 ? "green" : "red"}
                      key={item.monthName}
                    >
                      <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">
                          <div
                            className="ms-Grid-col ms-sm2"
                            title={
                              item.dataLockStatus === 2
                                ? "Production data is locked and cannot be modified"
                                : "Production data is opened to modifications"
                            }
                          >
                            {item.dataLockStatus === 2 ? (
                              <Lock color="green" />
                            ) : (
                              <AlertTriangle color="red" />
                            )}
                          </div>
                          <div
                            className="ms-Grid-col ms-sm6"
                            title={
                              item.dataLockStatus === 2
                                ? "Locked By"
                                : "Uploaded By"
                            }
                          >
                            <User />
                            {item.lockedBy}
                          </div>
                          <div
                            className="ms-Grid-col ms-sm4"
                            title={
                              item.dataLockStatus === 2
                                ? `Locked On ${moment(item.lockedOn).format(
                                    "LLLL"
                                  )}`
                                : `Uploaded On ${moment(item.lockedOn).format(
                                    "LLLL"
                                  )}`
                            }
                          >
                            {moment(item.lockedOn).fromNow()}
                          </div>
                        </div>
                      </div>
                    </Timeline.Item>
                  ))}
                </Timeline>
              }
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
});

